// Android pickers can provide a File backed by a temporary content-provider
// reference. Read the bytes before asynchronous network work so uploads do
// not depend on that reference remaining unchanged or accessible.
const stableFiles = new WeakSet()
const reads = new WeakMap()

export function markStableUploadFile(file) {
  stableFiles.add(file)
  return file
}

async function readFile(file) {
  try {
    const bytes = typeof file.arrayBuffer === "function"
      ? await file.arrayBuffer()
      : await new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = () => reject(reader.error)
        reader.onabort = () => reject(new Error("File reading was interrupted"))
        reader.readAsArrayBuffer(file)
      })
    if (bytes.byteLength !== file.size) throw new Error("Incomplete file read")
    return markStableUploadFile(new File([bytes], file.name, {
      type: file.type || "application/octet-stream",
      lastModified: file.lastModified,
    }))
  } catch {
    const error = new Error("Cannot read this photo from your device. Download it to your phone or select it again, then retry.")
    error.name = "FileReadError"
    throw error
  }
}

export async function stableUploadFile(file) {
  if (stableFiles.has(file)) return file
  if (reads.has(file)) return reads.get(file)
  const request = readFile(file)
  reads.set(file, request)
  try { return await request } finally { reads.delete(file) }
}
